/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { ArrowDownThin } from 'styles/assets/icons';
import { Product } from 'types/IProducts';

import { DeltaValue, GammaValue, ThetaValue, VeggaValue } from '../helpers';
import defaultStyles from './index.module.scss';

interface GreekProps {
  product: Product;
  classNames?: {
    button?: string;
    active?: string;
    label?: string;
    value?: string;
    itemLabel?: string;
    itemValue?: string;
    downArrow?: string;
    dropdownContainer?: string;
    itemContainer?: string;
  };
}

const GreeksDropdown = ({ product, classNames }: GreekProps) => {
  const { t } = useTranslation(['trading']);

  const styles = { ...defaultStyles, ...classNames };

  const isOperational = product && product.trading_status === 'operational';
  const greeksValues = [
    {
      id: 1,
      label: t('trading:gamma'),
      value: <GammaValue {...product} />,
    },
    {
      id: 2,
      label: t('trading:theta'),
      value: <ThetaValue {...product} />,
    },
    {
      id: 3,
      label: t('trading:vega'),
      value: <VeggaValue {...product} />,
    },
  ];

  return isOperational ? (
    <Menu
      menuButton={({ open }) => (
        <MenuButton
          data-testid="greek-expand-button"
          className={cn(styles.button, {
            [styles.active]: open && isOperational,
          })}
        >
          <span className={styles.label}>{t('trading:delta')}</span>
          <div className={styles.value}>
            <DeltaValue {...product} />
          </div>
          <ArrowDownThin className={cn({ [styles.downArrow]: open && isOperational })} />
        </MenuButton>
      )}
      menuClassName={styles.dropdownContainer}
    >
      {greeksValues.map(greek => (
        <MenuItem className={styles.itemContainer} key={greek.id}>
          <div className={styles.itemLabel}>{greek.label}</div>
          <div className={styles.itemValue}>{greek.value}</div>
        </MenuItem>
      ))}
    </Menu>
  ) : null;
};

export default GreeksDropdown;
